import React, { useContext, useEffect, useState } from 'react'

import { TheMasterContext } from '../../../../MyContexts/Master_Context';
import SelectGalleryComp from '../../../../MySections/ImagesSetter/SelectGalleryComp';
import SelectImgComp from '../../../../MySections/ImagesSetter/SelectImgComp';


const StaticPages = (props) => {
    const [theMaster] = useContext(TheMasterContext);
    const [mobiLineHead, setMobiLineHead] = useState(theMaster.mobiLineHead || "")
    const [staticPagesList, setStaticPagesList] = useState(theMaster.staticPagesList)

    useEffect(() => {
        theMaster["staticPagesList"] = staticPagesList;
    }, [staticPagesList])


    const setTehStaticPages = (fUrl, itemName, deskOrMobi) => {
        let fIndx = staticPagesList.findIndex(it => it.PageName === itemName)
        if (fIndx !== -1) {
            if (deskOrMobi === 1) {
                staticPagesList[fIndx].PageTopImage = fUrl;
                setStaticPagesList([...staticPagesList])
            }
            else if (deskOrMobi === 2) {
                staticPagesList[fIndx].PageTopImageMobi = fUrl;
                setStaticPagesList([...staticPagesList])
            }
        }
        else {
            if (deskOrMobi === 1) {
                let tempolst = [...staticPagesList, { PageName: itemName, PageTopImage: fUrl, PageTopImageMobi: "" }]
                setStaticPagesList(tempolst)
            }
            else if (deskOrMobi === 2) {
                let tempolst = [...staticPagesList, { PageName: itemName, PageTopImage: "", PageTopImageMobi: fUrl }]
                setStaticPagesList(tempolst)
            }
        }

    }

    return (
        <>

            <div className={"col-md-12 mb-2"}>
                <label htmlFor={"validationCustom1_61"}>עמודים סטאטיים</label>

            </div>

            <div className={"col-md-12 mb-2"}>

                <div className={"col-md-4 mb-12 onRight grayFrame"}>
                    <div className={"col-md-12 mb-12 onRight"}>
                        <label htmlFor={"validationCustom1_6"}>התחברות</label>
                    </div>
                    <div className={"col-md-6 mb-12 onRight"}>
                        <span className={"explanation mediumst "}>דסקטופ</span>
                        <SelectImgComp firstImgToDisp={staticPagesList.find(it => it.PageName === "LoginPage")?.PageTopImage ?
                            staticPagesList.find(it => it.PageName === "LoginPage")?.PageTopImage : ""}
                            theFunction={(fUrl) => { setTehStaticPages(fUrl, "LoginPage", 1) }} />
                    </div>
                    <div className={"col-md-6 mb-12 onRight"}>
                        <span className={"explanation mediumst "}>מובייל</span>
                        <SelectImgComp firstImgToDisp={staticPagesList.find(it => it.PageName === "LoginPage")?.PageTopImageMobi ?
                            staticPagesList.find(it => it.PageName === "LoginPage")?.PageTopImageMobi : ""}
                            theFunction={(fUrl) => { setTehStaticPages(fUrl, "LoginPage", 2) }} />
                    </div>
                </div>
                <div className={"col-md-4 mb-12 onRight grayFrame"}>
                    <div className={"col-md-12 mb-12 onRight"}>
                        <label htmlFor={"validationCustom1_6"}>רשום/חדש</label>
                    </div>
                    <div className={"col-md-6 mb-12 onRight"}>
                        <span className={"explanation mediumst "}>דסקטופ</span>
                        <SelectImgComp firstImgToDisp={staticPagesList.find(it => it.PageName === "LogOrRegPage")?.PageTopImage ?
                            staticPagesList.find(it => it.PageName === "LogOrRegPage")?.PageTopImage : ""}
                            theFunction={(fUrl) => { setTehStaticPages(fUrl, "LogOrRegPage", 1) }} />
                    </div>
                    <div className={"col-md-6 mb-12 onRight"}>
                        <span className={"explanation mediumst "}>מובייל</span>
                        <SelectImgComp firstImgToDisp={staticPagesList.find(it => it.PageName === "LogOrRegPage")?.PageTopImageMobi ?
                            staticPagesList.find(it => it.PageName === "LogOrRegPage")?.PageTopImageMobi : ""}
                            theFunction={(fUrl) => { setTehStaticPages(fUrl, "LogOrRegPage", 2) }} />

                    </div>
                </div>
                <div className={"col-md-4 mb-12 onRight grayFrame"}>
                    <div className={"col-md-12 mb-12 onRight"}>
                        <label htmlFor={"validationCustom1_6"}>הרשמה</label>
                    </div>
                    <div className={"col-md-6 mb-12 onRight"}>
                        <span className={"explanation mediumst "}>דסקטופ</span>
                        <SelectImgComp firstImgToDisp={staticPagesList.find(it => it.PageName === "RegisterP")?.PageTopImage ?
                            staticPagesList.find(it => it.PageName === "RegisterP")?.PageTopImage : ""}
                            theFunction={(fUrl) => { setTehStaticPages(fUrl, "RegisterP", 1) }} />
                    </div>
                    <div className={"col-md-6 mb-12 onRight"}>
                        <span className={"explanation mediumst "}>מובייל</span>
                        <SelectImgComp firstImgToDisp={staticPagesList.find(it => it.PageName === "RegisterP")?.PageTopImageMobi ?
                            staticPagesList.find(it => it.PageName === "RegisterP")?.PageTopImageMobi : ""}
                            theFunction={(fUrl) => { setTehStaticPages(fUrl, "RegisterP", 2) }} />

                    </div>
                </div>
                <div className={"col-md-4 mb-12 onRight grayFrame"}>
                    <div className={"col-md-12 mb-12 onRight"}>
                        <label htmlFor={"validationCustom1_6"}>כיף שחזרת</label>
                    </div>
                    <div className={"col-md-6 mb-12 onRight"}>
                        <span className={"explanation mediumst "}>דסקטופ</span>
                        <SelectImgComp firstImgToDisp={staticPagesList.find(it => it.PageName === "WelcomePop")?.PageTopImage ?
                            staticPagesList.find(it => it.PageName === "WelcomePop")?.PageTopImage : ""}
                            theFunction={(fUrl) => { setTehStaticPages(fUrl, "WelcomePop", 1) }} />
                    </div>
                    <div className={"col-md-6 mb-12 onRight"}>
                        <span className={"explanation mediumst "}>מובייל</span>
                        <SelectImgComp firstImgToDisp={staticPagesList.find(it => it.PageName === "WelcomePop")?.PageTopImageMobi ?
                            staticPagesList.find(it => it.PageName === "WelcomePop")?.PageTopImageMobi : ""}
                            theFunction={(fUrl) => { setTehStaticPages(fUrl, "WelcomePop", 2) }} />

                    </div>
                </div>
                <div className={"col-md-4 mb-12 onRight grayFrame"}>
                    <div className={"col-md-12 mb-12 onRight"}>
                        <label htmlFor={"validationCustom1_6"}>לא ניתן להזמין כרגע</label>
                    </div>
                    <div className={"col-md-6 mb-12 onRight"}>
                        <span className={"explanation mediumst "}>דסקטופ</span>
                        <SelectImgComp firstImgToDisp={staticPagesList.find(it => it.PageName === "noOrdersForNow")?.PageTopImage ?
                            staticPagesList.find(it => it.PageName === "noOrdersForNow")?.PageTopImage : ""}
                            theFunction={(fUrl) => { setTehStaticPages(fUrl, "noOrdersForNow", 1) }} />
                    </div>
                    <div className={"col-md-6 mb-12 onRight"}>
                        <span className={"explanation mediumst "}>מובייל</span>
                        <SelectImgComp firstImgToDisp={staticPagesList.find(it => it.PageName === "noOrdersForNow")?.PageTopImageMobi ?
                            staticPagesList.find(it => it.PageName === "noOrdersForNow")?.PageTopImageMobi : ""}
                            theFunction={(fUrl) => { setTehStaticPages(fUrl, "noOrdersForNow", 2) }} />

                    </div>
                </div>

            </div >



        </>

    );
}

export default StaticPages;